import { Paper, Typography, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";

type GameModeCardProps = {
    id?: number;
    gameMode: string;
    description: string;
};

export default function GameModeCard({id, gameMode, description}: GameModeCardProps) {
    const navigate = useNavigate();
    const theme = useTheme();
    const style = {
        margin: 2,
        padding: 2,
        minHeight: "150px",
        cursor: "pointer",
        transition: "0.2s",
        "&:hover": {
            transform: "scale(1.02)",
            backgroundColor: theme.palette.secondary.main,
        },
    };
    return (
        <Paper
            elevation={3}
            sx={style}
            onClick={() => navigate(`/create/${id}`)}
        >
            <Typography fontWeight={500} fontSize={"1.25rem"}>
                {gameMode}
            </Typography>
            <Typography color={theme.palette.secondary.light} marginTop={2}>
                {description}
            </Typography>
        </Paper>
    );
}
